import {postRequest, URL_SERVER} from './../requests'


export async function cancelOffer(offerId, token){
    const data = {
        "offer_id": offerId
    }
    try {
        return await postRequest(URL_SERVER + '/closeoperator', data, token)
    } catch (error) {
        console.error(error);
    }

}